import React from 'react'
import * as Layout from '../../components/layout'

export const routes = [
  {
    action: () => import(/* webpackChunkName: "PromotionsPage" */'./component')
      .then(({FullCalendarViewConnected}) =>
      <Layout.Layout>
        <FullCalendarViewConnected />
      </Layout.Layout>),
    path: '/content/calendar',
  },
]



// WEBPACK FOOTER //
// ./src/pages/content-calendar/routes.tsx